import { Injectable, Type } from '@angular/core';
import { CredentialType } from 'enums/CredentialType';
import { UserService } from 'services/user.service';

@Injectable()
export class CredentialService {

	constructor(private readonly userService: UserService) {
	}

	filterAccessibleComponents(componentTypes: Type<Object>[]): Type<Object>[] {
		const userCredentials = this.userService.getCredentials();
		const validComponents: Type<Object>[] = [];
		componentTypes.forEach(componentType => {
			const requiredCredential = componentCredentials.get(componentType);
			if (requiredCredential === undefined) validComponents.push(componentType);
			else if (requiredCredential.every(rc => userCredentials.some(uc => uc === rc))) validComponents.push(componentType);
		});
		return validComponents;
	}

	hasCredentials(...requiredCredentials: CredentialType[]): boolean {
		const userCredentials = this.userService.getCredentials();
		if (requiredCredentials === undefined)
			return true;
		else if (requiredCredentials.every(rc => userCredentials.some(uc => uc === rc)))
			return true;
		else
			return false;
	}

	hasCustomCredentials(...requiredCredentials: string[]): boolean {
		const userCredentials = this.userService.getCustomCredentials();
		if (requiredCredentials === undefined)
			return true;
		else if (requiredCredentials.every(rc => userCredentials.some(uc => uc === rc)))
			return true;
		else
			return false;
	}

}

let componentCredentials = new Map<Type<Object>, CredentialType[]>();

export function CredentialRequired(...credentials: CredentialType[]): (cls: any) => any {
	return (componentType: any) => {
		componentCredentials.set(componentType, credentials);
	}
}
